import { useAuth } from './hooks';

export function OAuth() {
  useAuth();

  return null;
}
